import React from "react";

const SilverAwardSVG = ({
    curvedText = "POINT RANGE 2·29 · INDUSTRY · MAY 2025",
    curvedTextColor = "#000",
    curvedTextFontSize = 16,
    curvedTextFontWeight = 700,
    curvedTextFontFamily = "'Gotham HTF', GothamHTF-Bold2, sans-serif",
    curvedTextOffset = "26%",
}) => {
    return (
        <svg
            id="a"
            data-name="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 524.41 524.41"
        >
            <defs>
                <style>
                    {`.d {
                font-size: 16px;
              }
        
              .d, .e, .f, .g, .h, .i, .j, .k, .l, .m, .n, .o, .p, .q, .r, .s, .t, .u, .v, .w, .x, .y {
                font-weight: 700;
              }
        
              .d, .e, .f, .g, .h, .i, .j, .k, .l, .n, .o, .p, .q, .r, .s, .t, .u, .v, .w, .x, .y {
                font-family: Montserrat-Bold, Montserrat;
              }
        
              .d, .e, .g, .h, .i, .j, .z, .n, .p, .r, .t, .v, .x {
                fill: #231f20;
              }
        
              .e {
                font-size: 16px;
              }
        
              .f {
                font-size: 28px;
              }
        
              .f, .aa, .k, .l, .o, .q, .s, .u, .w, .y {
                fill: #fff;
              }
        
              .ab {
                letter-spacing: 0em;
              }
        
              .g {
                font-size: 16px;
              }
        
              .ac {
                fill: url(#c);
              }
        
              .h {
                font-size: 16px;
              }
        
              .i {
                font-size: 16px;
              }
        
              .ad {
                fill: none;
              }
        
              .ae {
                fill: #ee3137;
                font-family: Montserrat-Black, Montserrat;
                font-size: 41px;
                font-weight: 800;
                letter-spacing: -.04em;
              }
        
              .af {
                letter-spacing: 0em;
              }
        
              .j {
                font-size: 16px;
              }
        
              .k {
                font-size: 28px;
              }
        
              .ag {
                clip-path: url(#b);
              }
        
              .l {
                font-size: 28px;
              }
        
              .m {
                font-family: Raleway-ExtraBold, Raleway;
                font-size: 18px;
              }
        
              .m, .ah {
                fill: #ec2027;
              }
        
              .n {
                font-size: 16px;
              }
        
              .o {
                font-size: 28px;
              }
        
              .ai {
                letter-spacing: -.01em;
              }
        
              .p {
                font-size: 16px;
              }
        
              .q {
                font-size: 28px;
              }
        
              .r {
                font-size: 16px;
              }
        
              .s {
                font-size: 28px;
              }
        
              .t {
                font-size: 16px;
              }
        
              .u {
                font-size: 28px;
              }
        
              .aj {
                fill: #de2628;
              }
        
              .v {
                font-size: 16px;
              }
        
              .w {
                font-size: 28px;
              }
        
              .ak {
                letter-spacing: 0em;
              }
        
              .x {
                font-size: 16px;
              }
        
              .y {
                font-size: 28px;
              }`}
                </style>
                <clipPath id="b">
                    <path
                        class="ad"
                        d="M0,262.21c0,144.81,117.39,262.2,262.2,262.2s262.21-117.39,262.21-262.2S407.02,0,262.2,0,0,117.39,0,262.21"
                    />
                </clipPath>
                <linearGradient
                    id="c"
                    x1="-113.13"
                    y1="637.04"
                    x2="-112.13"
                    y2="637.04"
                    gradientTransform="translate(334329.92 -58799.93) rotate(-90) scale(524.41 -524.41)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#77787b" />
                    <stop offset="1" stop-color="#cdcfd0" />
                </linearGradient>
            </defs>
            <g class="ag">
                <rect class="ac" width="524.41" height="524.41" />
            </g>
            <path
                class="aa"
                d="M462.05,262.21c0,110.37-89.47,199.84-199.84,199.84S62.36,372.58,62.36,262.21,151.84,62.36,262.21,62.36s199.84,89.47,199.84,199.84"
            />
            <text class="f" transform="translate(132.97 79.13) rotate(-32.32)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    S
                </tspan>
            </text>
            <text class="l" transform="translate(152.37 67.06) rotate(-27.47)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    I
                </tspan>
            </text>
            <text class="o" transform="translate(165.24 60.13) rotate(-23.28)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    L
                </tspan>
            </text>
            <text class="u" transform="translate(182.6 52.51) rotate(-17.63)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    V
                </tspan>
            </text>
            <text class="y" transform="translate(207.12 44.87) rotate(-11.21)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    E
                </tspan>
            </text>
            <text class="u" transform="translate(230.14 40.15) rotate(-4.71)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    R
                </tspan>
            </text>
            <text class="l" transform="translate(266.59 38.26) rotate(2.54)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    {" "}
                </tspan>
            </text>
            <text class="y" transform="translate(279.88 38.64) rotate(7.61)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    A
                </tspan>
            </text>
            <text class="s" transform="translate(303.95 41.35) rotate(15.5)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    W
                </tspan>
            </text>
            <text class="w" transform="translate(336.02 50.27) rotate(23.28)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    A
                </tspan>
            </text>
            <text class="q" transform="translate(360.77 60.8) rotate(29.55)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    R
                </tspan>
            </text>
            <text class="k" transform="translate(382.55 73.13) rotate(35.76)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    D
                </tspan>
            </text>
            <text class="k" transform="translate(44.19 367) rotate(58.37)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    W
                </tspan>
            </text>
            <text class="k" transform="translate(64.46 399.97) rotate(49.44)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    W
                </tspan>
            </text>
            <text class="k" transform="translate(89.84 429.29) rotate(40.56)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    W
                </tspan>
            </text>
            <text class="k" transform="translate(117.11 451.97) rotate(35.07)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    .
                </tspan>
            </text>
            <text class="k" transform="translate(129.18 460.76) rotate(29.55)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    A
                </tspan>
            </text>
            <text class="k" transform="translate(153.43 474.56) rotate(23.28)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    C
                </tspan>
            </text>
            <text class="k" transform="translate(179 485.39) rotate(16.92)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    T
                </tspan>
            </text>
            <text class="k" transform="translate(202.92 492.45) rotate(11.92)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    I
                </tspan>
            </text>
            <text class="k" transform="translate(218.77 496.11) rotate(6.88)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    O
                </tspan>
            </text>
            <text class="k" transform="translate(249.63 499.68) rotate(-.36)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    N
                </tspan>
            </text>
            <text class="k" transform="translate(278.73 499.31) rotate(-6.16)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    -
                </tspan>
            </text>
            <text class="k" transform="translate(296.89 497.58) rotate(-11.21)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    C
                </tspan>
            </text>
            <text class="k" transform="translate(324.11 492.01) rotate(-17.63)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    A
                </tspan>
            </text>
            <text class="k" transform="translate(351.96 482.91) rotate(-24.68)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    R
                </tspan>
            </text>
            <text class="k" transform="translate(376.81 471.5) rotate(-30.94)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    D
                </tspan>
            </text>
            <text class="k" transform="translate(401.33 456.49) rotate(-37.82)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    S
                </tspan>
            </text>
            <text class="k" transform="translate(420.58 441.32) rotate(-41.93)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    .
                </tspan>
            </text>
            <text class="k" transform="translate(430.93 432.37) rotate(-46.71)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    C
                </tspan>
            </text>
            <text class="k" transform="translate(449.73 412.47) rotate(-53.55)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    O
                </tspan>
            </text>
            <text class="k" transform="translate(468.03 387.53) rotate(-60.45)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    M
                </tspan>
            </text>

            <defs>
                <path
                    id="bottom-arc"
                    d="
              M 252,256
              m -180,6
              a 190,190 0 0,0 380,0
              a 190,190 0 0,0 -400,0"
                />
            </defs>

            <text
                font-size={curvedTextFontSize}
                font-weight={curvedTextFontWeight}
                fontWeight={curvedTextFontWeight}
                fontFamily={curvedTextFontFamily}
                fill={curvedTextColor}
            >
                <textPath
                    href="#bottom-arc"
                    startOffset={curvedTextOffset}
                    text-anchor="middle"
                    side="left"
                >
                    {curvedText}
                </textPath>
            </text>

            <text class="m" transform="translate(190.3 388.4)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    A
                </tspan>
                <tspan
                    class="ab"
                    x="12.06"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    C
                </tspan>
                <tspan
                    x="24.41"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    TION-
                </tspan>
                <tspan
                    class="ai"
                    x="75.81"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    C
                </tspan>
                <tspan
                    x="88"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    AR
                </tspan>
                <tspan
                    class="ak"
                    x="112.12"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    D
                </tspan>
                <tspan
                    class="af"
                    x="124.94"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    S
                </tspan>
            </text>
            <path
                class="ah"
                d="M329.65,382.48c-.58,0-1.11-.1-1.6-.29-.49-.19-.9-.46-1.25-.8-.35-.34-.62-.74-.82-1.2-.2-.46-.3-.97-.3-1.51s.1-1.04.3-1.5c.2-.46.47-.86.82-1.2.35-.34.77-.6,1.25-.79.49-.19,1.02-.29,1.6-.29s1.11.1,1.6.29.92.46,1.28.79c.36.33.64.73.84,1.2.2.46.3.96.3,1.5s-.1,1.05-.3,1.51c-.2.46-.48.86-.84,1.2-.36.34-.79.61-1.28.8s-1.03.29-1.6.29ZM329.66,381.9c.47,0,.91-.08,1.31-.24.41-.16.76-.38,1.06-.67.3-.28.54-.62.71-1.01.17-.39.26-.82.26-1.28s-.08-.87-.25-1.26c-.17-.39-.4-.73-.7-1.02-.3-.29-.65-.51-1.05-.68-.41-.17-.85-.25-1.33-.25s-.93.08-1.33.25c-.41.17-.75.4-1.05.68s-.52.62-.69,1.01c-.17.39-.25.81-.25,1.25s.08.87.25,1.25c.16.39.39.73.69,1.02.29.29.64.52,1.05.69.41.17.85.25,1.33.25ZM327.91,376.38h2.07c.22,0,.42.05.6.14s.34.21.48.36c.13.15.24.31.31.5.07.19.11.37.11.56,0,.27-.07.53-.21.77s-.32.42-.55.54l1.04,1.69h-1.31l-.91-1.47h-.44v1.47h-1.19v-4.55ZM329.86,378.46c.13,0,.24-.04.33-.13s.13-.22.13-.4c0-.2-.05-.33-.15-.41-.1-.08-.21-.12-.33-.12h-.75v1.05h.77Z"
            />
            <rect x="256.45" y="299.18" width="31.96" height="1.96" />
            <rect x="256.48" y="320.69" width="31.96" height="1.96" />
            <path d="M249.74,291.49s-6.77,5.12-10.09,10.42c0,0-1.15-2-2.39-2.89l-1.86,1.56s3.05,3.25,3.19,5.66l2.43-1.38s.84-5.12,9.51-12.38l-.8-.98Z" />
            <path d="M249.83,313.3s-6.77,5.12-10.09,10.42c0,0-1.15-2-2.39-2.89l-1.86,1.56s3.05,3.25,3.19,5.66l2.43-1.38s.84-5.12,9.51-12.38l-.8-.98Z" />
            <path d="M227.69,225.62c-5.13,0-9.29,4.17-9.29,9.3v101.61c0,5.12,4.17,9.29,9.29,9.29h69.02c5.12,0,9.29-4.17,9.29-9.29v-101.61c0-5.13-4.17-9.3-9.29-9.3h-69.02ZM296.71,347.24h-69.02c-5.91,0-10.73-4.81-10.73-10.72v-101.61c0-5.91,4.81-10.73,10.73-10.73h69.02c5.91,0,10.73,4.81,10.73,10.73v101.61c0,5.91-4.81,10.72-10.73,10.72" />
            <path
                class="aj"
                d="M288.98,266.7c-2.64,2.4-4.99,3.93-8.82,3.93-5.75,0-9.73-4.8-9.73-10.55v-.1c0-5.75,4.08-10.45,9.73-10.45,3.36,0,5.99,1.44,8.58,3.79l4.7-5.42c-3.12-3.07-6.91-5.18-13.24-5.18-9.16,0-15.86,6.18-17.24,14.25l-6.44-.02-5.91-13.89h-6.81l-14.39,33.81h7.53l5.35-13.42h9.52l5.46,13.42h7.72l-5.73-13.46,3.71.02c1.44,8.05,8.19,14.02,16.93,14.02,6.47,0,10.31-2.3,13.76-5.99l-4.7-4.75ZM245.04,256.99l2.08-5.06,2.03,5.06h-4.11Z"
            />
            <text class="ae" transform="translate(141.66 152.17)">
                <tspan
                    x="0"
                    y="0"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    CONFIDENT
                </tspan>
                <tspan
                    x="18.96"
                    y="42.2"
                    fontFamily="'Gotham HTF', GothamHTF-Bold2, sans-serif"
                >
                    FIRST-AID
                </tspan>
            </text>
        </svg>
    );
};

export default SilverAwardSVG;
